// src/App.js
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { checkAuthState } from './store/actions/authActions';
import LoginPage from './pages/LoginPage';
import './App.css';
import ProtectedLayout from './components/layout/ProtectedLayout';
import { protectedRoutes } from './utils/routes';

function App() {
  const dispatch = useDispatch();
  const [darkMode, setDarkMode] = useState(false);
  useEffect(() => {
    // Check if user is authenticated when app loads
    dispatch(checkAuthState());
  }, [dispatch]);

  const renderProtectedRoute = (element) => (
    <ProtectedLayout darkMode={darkMode} setDarkMode={setDarkMode}>
      {element}
    </ProtectedLayout>
  );
   return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          
          {protectedRoutes.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={renderProtectedRoute(element)}
            />
          ))}
        </Routes>
      </div>
    </Router>
  );
          
}

export default App;